import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import { TransitionScreen } from '../../TransitionScreen';
import { IconXirpBranding, IconXirpMark } from './IconXirp';

import styles from './XirpEmailVerifiedPage.module.css';

const XirpEmailVerifiedPageComponent = () => {
  return (
    <div className={styles.root}>
      <div className={styles.branding}>
        <IconXirpBranding />
      </div>
      <TransitionScreen
        title="Email verified!"
        description="Your email has been verified. You can close this tab and return to the signup window."
        graphics={<IconXirpMark width={120} height={120} />}
      />
    </div>
  );
};

export const XirpEmailVerifiedPage = withPageImpression(
  XirpEmailVerifiedPageComponent,
  { pageId: 'xirp-email-verified' },
);
